import { BaseItemTypes } from "@/components/dnd/ItemTypes";
import { AnalyticsElementIdentity, AnalyticsElementKind } from "@/models/interfaces/entity-settings/charts/charts";

/**
 * Строгое сравнение Identity табличного элемента по всем полям.
 * Source есть только у проекций, поэтому его отсутствие и null считаются одним и тем же.
 * Сверка по !== undefined, а не по truthy, так как Kind 0 это выборка, а Destination 0 это проект.
 */
export function sameAnalyticsElementIdentity(
  a: AnalyticsElementIdentity | undefined,
  b: AnalyticsElementIdentity | undefined): boolean {
  if (!a || !b) return false;
  if (a.ElementId === undefined || b.ElementId === undefined) return false;
  if (a.Kind === undefined || b.Kind === undefined) return false;
  if (a.Destination === undefined || b.Destination === undefined) return false;

  return a.ElementId === b.ElementId &&
    a.Kind === b.Kind &&
    a.Destination === b.Destination &&
    (a.Source ?? null) === (b.Source ?? null);
}

/** Обратная сторона getIdentityKind: из Kind в тип узла дерева. */
export function elTypeFromIdentityKind(kind: AnalyticsElementKind | undefined): BaseItemTypes | undefined {
  if (kind === AnalyticsElementKind.Selection) return BaseItemTypes.SELECTION;
  if (kind === AnalyticsElementKind.Projection) return BaseItemTypes.PROJECTION;
  if (kind === AnalyticsElementKind.List) return BaseItemTypes.LIST;
  return undefined;
}
